import { render, staticRenderFns } from "./BannerItems.vue?vue&type=template&id=21077566"
import script from "./BannerItems.vue?vue&type=script&lang=js"
export * from "./BannerItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports